import RMTable from 'components/customComponents/Controls/RMTable';
import React, { useMemo, useEffect, useState, useContext } from 'react';
import { ReactComponent as DeleteIcon } from 'Icons/CommandPanel/Delete_Dark.svg';
import { isNullOrUndefined } from 'utils/Global';
import ScreenWizardContext from './ScreenWizardContext';
import { PlateTypeDTO, ProteinInfoDTO } from 'business/models/Models';
import TableInput from './TableInput';
import LayersError from 'components/customComponents/Layers/LayersError';
import DropUpDown from 'components/customComponents/Controls/DropUpDown';
import './ScreenExperimentWizard.scss';

type ProteinRowModel = {
  name: string;
  dropNumber: any;
  dropVolume: any;
  solutionVolume: any;
  delete: any;
};

function SelectedProteins({ item = null }: any) {
  const screenExpWiz = useContext(ScreenWizardContext);
  const plateType: PlateTypeDTO = screenExpWiz.plateType;
  const lProteins = screenExpWiz.proteins;
  const [proteinsError, setProteinsError] = useState<string[]>([]);
  const [data, setData] = useState<ProteinRowModel[]>([]);

  useEffect(() => {
    if (isNullOrUndefined(item)) {
      return;
    }
    const dropsNumber = plateType.enabledDropNumbers?.length;
    let tempItem = [];
    if (item.length > dropsNumber) {
      tempItem = item.slice(0, dropsNumber);
    } else {
      tempItem = item.map((i) => {
        return { ...i };
      });
    }
    if (lProteins.length < dropsNumber) {
      for (let i = 0; i < lProteins.length; i++) {
        if (lProteins[i] && !lProteins[i].name && tempItem.length) {
          lProteins[i].name = tempItem[0].name;
          lProteins[i].pfId = tempItem[0].pfId;
          lProteins[i].id = tempItem[0].id;
          tempItem.splice(0, 1);
        }
      }
      screenExpWiz.changeProteins([...lProteins, ...tempItem]);
    } else {
      tempItem.forEach((item) => {
        const insertIndex = lProteins.findIndex((protein) => protein == null);
        const proteinNameIndex = lProteins.findIndex(
          (protein) => protein?.name == undefined,
        );
        if (insertIndex != -1) {
          lProteins[insertIndex] = item;
        } else if (proteinNameIndex != -1) {
          lProteins[proteinNameIndex] = item;
        }
      });
      screenExpWiz.changeProteins([...lProteins]);
    }
  }, [item]);

  useEffect(() => {
    if (proteinsError.length > 0) {
      screenExpWiz.setProteinVolError(true);
    } else {
      screenExpWiz.setProteinVolError(false);
    }
  }, [proteinsError]);
  function getEmptyProtein(dropNumber): ProteinRowModel {
    return {
      name: null,
      dropNumber: (
        <DropUpDown
          val={dropNumber}
          onDownClick={onProteinDown}
          onUpClick={onProteinUp}
          upDisabled={true}
          downDisabled={true}
        />
      ),
      dropVolume: null,
      solutionVolume: null,
      delete: (
        <DeleteIcon
          id="selectedprotein-del-icon"
          onClick={() => {}}
          style={{ cursor: 'pointer' }}
          className="grey-svg"
        />
      ),
    };
  }

  function getInitailDrops(pType: PlateTypeDTO) {
    const initialDrops: ProteinRowModel[] = [];
    pType?.enabledDropNumbers?.forEach((drop) => {
      initialDrops.push(getEmptyProtein(drop));
    });
    return initialDrops;
  }
  function getErrorsView(errors: string[]) {
    return errors.map((error, index) => (
      <LayersError
        key={`lyrError${index}`}
        style={{ padding: '10px' }}
        errorText={`${error}-Layer volume must in value range (0 - ${screenExpWiz.plateType.dropVolume})`}
      />
    ));
  }

  function onProteinUp(index) {
    if (isNullOrUndefined(screenExpWiz.proteins[index])) {
      return;
    }
    if (index == 0) {
      return;
    }
    const currProtein = { ...screenExpWiz.proteins[index] };
    const replacedProtein = { ...screenExpWiz.proteins[index - 1] };
    if (!isNullOrUndefined(screenExpWiz.proteins[index])) {
      screenExpWiz.proteins[index].name = replacedProtein.name;
    }
    if (!isNullOrUndefined(screenExpWiz.proteins[index - 1])) {
      screenExpWiz.proteins[index - 1].name = currProtein.name;
    } else {
      screenExpWiz.proteins[index - 1] = { ...currProtein } as ProteinInfoDTO;
    }
    screenExpWiz.changeProteins([...screenExpWiz.proteins]);
  }

  function onProteinDown(index) {
    if (index == screenExpWiz.proteins.length - 1) {
      return;
    }
    const currProtein = { ...screenExpWiz.proteins[index] };
    const replacedProtein = { ...screenExpWiz.proteins[index + 1] };
    if (!isNullOrUndefined(screenExpWiz.proteins[index])) {
      screenExpWiz.proteins[index].name = replacedProtein.name;
    }
    if (!isNullOrUndefined(screenExpWiz.proteins[index + 1])) {
      screenExpWiz.proteins[index + 1].name = currProtein.name;
    } else {
      screenExpWiz.proteins[index + 1] = { ...currProtein } as ProteinInfoDTO;
    }
    screenExpWiz.changeProteins([...screenExpWiz.proteins]);
  }

  function getProteinsView(
    proteins: (ProteinInfoDTO | null)[],
    values: ProteinRowModel[],
  ) {
    const viewArray = values.map((protein, index) => {
      const prot = proteins[index];
      function changeDropVol(value: string) {
        const name = prot.name;
        const maxValue = screenExpWiz.plateType.dropVolume;
        const floatVal = parseFloat(value);
        const numVal = floatVal + prot.proteinVolume;
        if (numVal > maxValue || numVal < 0 || value.length == 0) {
          const existedScreen = proteinsError.find((screen) => screen == name);
          if (isNullOrUndefined(existedScreen)) {
            proteinsError.push(name);
            setProteinsError([...proteinsError]);
          }
        } else {
          const deleteIndex = proteinsError.findIndex((screen) => screen == name);
          if (deleteIndex != -1) {
            proteinsError.splice(deleteIndex, 1);
          }
          setProteinsError([...proteinsError]);
        }
        prot.dropVolume = floatVal;
      }
      function changeProteinVol(value: string) {
        const name = prot.name;
        const maxValue = screenExpWiz.plateType.dropVolume;
        const floatVal = parseFloat(value);
        const numVal = floatVal + prot.dropVolume;
        if (numVal > maxValue || numVal < 0 || value.length == 0) {
          const existedProtein = proteinsError.find((ptein) => ptein == name);
          if (isNullOrUndefined(existedProtein)) {
            proteinsError.push(name);
            setProteinsError([...proteinsError]);
          }
        } else {
          const deleteIndex = proteinsError.findIndex(
            (proteinName) => proteinName == name,
          );
          if (deleteIndex != -1) {
            proteinsError.splice(deleteIndex, 1);
          }
          setProteinsError([...proteinsError]);
        }
        prot.proteinVolume = floatVal;
      }
      if (!isNullOrUndefined(prot)) {
        return {
          name: prot.name,
          dropNumber: (
            <DropUpDown
              val={index + 1}
              onDownClick={() => onProteinDown(index)}
              onUpClick={() => onProteinUp(index)}
              upDisabled={index == 0 || isNullOrUndefined(prot.name)}
              downDisabled={
                index == screenExpWiz.proteins.length - 1 || isNullOrUndefined(prot.name)
              }
            />
          ),
          dropVolume: (
            <TableInput
              initialValue={prot.dropVolume.toString()}
              changeInputValue={changeDropVol}
              disabled={isNullOrUndefined(prot.name)}
              customStyle={{ width: '75%', maxWidth: '75%' }}
              step={0.1}
            />
          ),
          solutionVolume: (
            <TableInput
              initialValue={prot.proteinVolume.toString()}
              changeInputValue={changeProteinVol}
              disabled={isNullOrUndefined(prot.name)}
              customStyle={{ width: '75%', maxWidth: '75%' }}
              step={0.1}
            />
          ),
          delete: (
            <DeleteIcon
              id="selectedprotein-del-protein-icon"
              onClick={() => deleteProtein(index)}
              style={{ cursor: 'pointer' }}
            />
          ),
        };
      } else {
        return getEmptyProtein(index + 1);
      }
    });

    setData([...viewArray]);
  }
  useEffect(() => {
    const initialProtein = getInitailDrops(plateType);
    setData(initialProtein);
    if (lProteins.length > 0) {
      getProteinsView(lProteins, initialProtein);
    }
  }, [lProteins]);

  function deleteAllProteins() {
    screenExpWiz.changeProteins([]);
  }
  function deleteProtein(delIndex) {
    lProteins[delIndex] = null;
    screenExpWiz.changeProteins([...lProteins]);
  }
  const columns = useMemo(
    () => [
      {
        Header: 'Protein Name',
        accessor: 'name',
        className: 'rmtable-custom-style1 col-6 overflow-hidden text-ellipsis',
      },
      {
        Header: 'Drop',
        accessor: 'dropNumber',
        className: 'col-2',
      },
      {
        Header: 'Drop Vol(µL)',
        accessor: 'dropVolume',
        className: 'col-2',
      },
      {
        Header: 'Solution Vol(µL)',
        accessor: 'solutionVolume',
        className: 'col-2',
      },
      {
        Header: (
          <DeleteIcon
            id="selectedprotein-del-all"
            onClick={deleteAllProteins}
            className="cursor-pointer"
          />
        ),
        accessor: 'delete',
        className: 'col-2',
      },
    ],
    [],
  );

  return (
    <>
      <div
        id="selectedprotein-table-container"
        style={{ height: '80%', overflow: 'auto' }}
      >
        <RMTable columns={columns} data={data} mainContainerStyle={{ height: '100%' }} />
      </div>
      <div
        id="selectedprotein-error-container"
        style={{ height: '20%', overflow: 'auto' }}
      >
        {getErrorsView(proteinsError)}
      </div>
    </>
  );
}

export default SelectedProteins;
